class W4D_PageLoader {
	loader = null;
	observer = null;
	hideTimeout = null;
	fallbackTimeout = null;
	defaultLabel = 'Molimo pričekajte...';

	show(label = this.defaultLabel) {
		const template = document.getElementById('page-loader-template');

		if (!template) {
			console.error('Cannot show page loader: template #page-loader-template was not found.');
			return;
		}

		this.clearTimers();
		this.disconnectObserver();

		if (!this.loader) {
			this.loader = template.content.firstElementChild.cloneNode(true);
			this.loader.id = 'page-loader';
			document.body.appendChild(this.loader);
		}

		const loaderLabel = label || this.defaultLabel;
		const loaderText = this.loader.querySelector('p');

		if (loaderText) {
			loaderText.textContent = loaderLabel;
		}

		this.loader.setAttribute('aria-label', loaderLabel);

		if (typeof this.loader.showPopover !== 'function') {
			console.error('Cannot show page loader: Popover API is unavailable.');
			return;
		}

		try {
			this.loader.showPopover();
		} catch (error) {
			console.error('Failed to open page loader popover:', error);
			return;
		}

		this.observer = new MutationObserver(() => this.scheduleHide());
		this.observer.observe(document.body, {
			childList: true,
			subtree: true,
			characterData: true,
		});

		this.fallbackTimeout = setTimeout(() => this.hide(), 3000);
	}

	scheduleHide() {
		clearTimeout(this.hideTimeout);
		this.hideTimeout = setTimeout(() => this.hide(), 1000);
	}

	hide() {
		this.clearTimers();
		this.disconnectObserver();

		if (this.loader && typeof this.loader.hidePopover === 'function' && this.loader.matches(':popover-open')) {
			this.loader.hidePopover();
		}
	}

	clearTimers() {
		clearTimeout(this.hideTimeout);
		clearTimeout(this.fallbackTimeout);
		this.hideTimeout = null;
		this.fallbackTimeout = null;
	}

	disconnectObserver() {
		if (this.observer) {
			this.observer.disconnect();
			this.observer = null;
		}
	}
}

export default new W4D_PageLoader();
